import { render } from "./QuestionSix.vue?vue&type=template&id=7954b517"
import script from "./QuestionSix.vue?vue&type=script&lang=js"
export * from "./QuestionSix.vue?vue&type=script&lang=js"

import "./QuestionSix.vue?vue&type=style&index=0&id=7954b517&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__